export default __webpack_public_path__ + "static/media/klogo.20844154.png";